export default __webpack_public_path__ + "static/media/G0510.34I-26281_-17354_0.1666264140000.b3d73d28.jpg";